module.exports = __webpack_public_path__ + "media/images/icons/full-star-2e96f90b7a2ef7b5714a0b755c8ab2dd.svg";